import React, { useState, useEffect } from 'react';
import logo from '../../images/logo.png';
import { X } from 'lucide-react';
import { Link } from 'react-router-dom';

interface NavItem {
  label: string;
  href?: string;
  subcategories?: NavCategory[];
}

interface NavCategory {
  title: string;
  items: NavSubItem[];
}

interface NavSubItem {
  label: string;
  href: string;
}

const mockNavItems: NavItem[] = [
  { label: 'Deals', href: 'shop' },
  { label: 'Gaming PCs', href: 'shop' },
  {
    label: 'Components',
    subcategories: [
      {
        title: 'CASES',
        items: [
          { label: 'H9', href: 'shop' },
          { label: 'H7', href: 'shop' },
          { label: 'H6', href: 'shop' },
          { label: 'H5', href: 'shop' },
        ],
      },
      {
        title: 'FANS',
        items: [
          { label: 'RGB', href: 'shop' },
          { label: 'Quiet Airflow', href: 'shop' },
          { label: 'Static Pressure', href: 'shop' },
        ],
      },
      {
        title: 'CASES',
        items: [
          { label: 'H9', href: 'shop' },
          { label: 'H7', href: 'shop' },
          { label: 'H6', href: 'shop' },
          { label: 'H5', href: 'shop' },
        ],
      },
      {
        title: 'FANS',
        items: [
          { label: 'RGB', href: 'shop' },
          { label: 'Quiet Airflow', href: 'shop' },
          { label: 'Static Pressure', href: 'shop' },
        ],
      },
      {
        title: 'FANS',
        items: [
          { label: 'RGB', href: 'shop' },
          { label: 'Quiet Airflow', href: 'shop' },
          { label: 'Static Pressure', href: 'shop' },
        ],
      },
      {
        title: 'FANS',
        items: [
          { label: 'RGB', href: 'shop' },
          { label: 'Quiet Airflow', href: 'shop' },
          { label: 'Static Pressure', href: 'shop' },
        ],
      },
      {
        title: 'POWER SUPPLIES',
        items: [
          { label: 'Platinum', href: 'shop' },
          { label: 'Gold', href: 'shop' },
          { label: 'Bronze', href: 'shop' },
        ],
      },
      {
        title: 'ACCESSORIES',
        items: [
          { label: 'Controllers', href: 'shop' },
          { label: 'PCIe Riser Cable', href: 'shop' },
          { label: 'Vertical GPU Mounting Kit', href: 'shop' },
          { label: 'Internal USB Hub', href: 'shop' },
          { label: 'Puck', href: 'shop' },
        ],
      },
      {
        title: 'CASES',
        items: [
          { label: 'H9', href: 'shop' },
          { label: 'H7', href: 'shop' },
          { label: 'H6', href: 'shop' },
          { label: 'H5', href: 'shop' },
        ],
      },
      {
        title: 'FANS',
        items: [
          { label: 'RGB', href: 'shop' },
          { label: 'Quiet Airflow', href: 'shop' },
          { label: 'Static Pressure', href: 'shop' },
        ],
      },
      {
        title: 'CASES',
        items: [
          { label: 'H9', href: 'shop' },
          { label: 'H7', href: 'shop' },
          { label: 'H6', href: 'shop' },
          { label: 'H5', href: 'shop' },
        ],
      },
      {
        title: 'FANS',
        items: [
          { label: 'RGB', href: 'shop' },
          { label: 'Quiet Airflow', href: 'shop' },
          { label: 'Static Pressure', href: 'shop' },
        ],
      },
      {
        title: 'FANS',
        items: [
          { label: 'RGB', href: 'shop' },
          { label: 'Quiet Airflow', href: 'shop' },
          { label: 'Static Pressure', href: 'shop' },
        ],
      },
      {
        title: 'FANS',
        items: [
          { label: 'RGB', href: 'shop' },
          { label: 'Quiet Airflow', href: 'shop' },
          { label: 'Static Pressure', href: 'shop' },
        ],
      },
      {
        title: 'POWER SUPPLIES',
        items: [
          { label: 'Platinum', href: 'shop' },
          { label: 'Gold', href: 'shop' },
          { label: 'Bronze', href: 'shop' },
        ],
      },
      {
        title: 'ACCESSORIES',
        items: [
          { label: 'Controllers', href: 'shop' },
          { label: 'PCIe Riser Cable', href: 'shop' },
          { label: 'Vertical GPU Mounting Kit', href: 'shop' },
          { label: 'Internal USB Hub', href: 'shop' },
          { label: 'Puck', href: 'shop' },
        ],
      },
    ],
  },
  { label: 'Gaming Gear', href: 'shop' },
  { label: 'Monitors', href: 'shop' },
  { label: 'Software',subcategories: [
    {
      title: 'CASES',
      items: [
        { label: 'H9', href: 'shop' },
        { label: 'H7', href: 'shop' },
        { label: 'H6', href: 'shop' },
        { label: 'H5', href: 'shop' },
      ],
    },
    {
      title: 'FANS',
      items: [
        { label: 'RGB', href: 'shop' },
        { label: 'Quiet Airflow', href: 'shop' },
        { label: 'Static Pressure', href: 'shop' },
      ],
    },
    {
      title: 'POWER SUPPLIES',
      items: [
        { label: 'Platinum', href: 'shop' },
        { label: 'Gold', href: 'shop' },
        { label: 'Bronze', href: 'shop' },
      ],
    },
    {
      title: 'ACCESSORIES',
      items: [
        { label: 'Controllers', href: 'shop' },
        { label: 'PCIe Riser Cable', href: 'shop' },
        { label: 'Vertical GPU Mounting Kit', href: 'shop' },
        { label: 'Internal USB Hub', href: 'shop' },
        { label: 'Puck', href: 'shop' },
      ],
    },
  ], },
  { label: 'Community3', href: 'shop' },
];

const Navbar: React.FC = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState<number | null>(null);
  const [isSearchOpen, setIsSearchOpen] = useState<boolean>(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showSubMenu, setShowSubMenu] = useState(false);
  const [currentSubMenu, setCurrentSubMenu] = useState<NavCategory[] | null>(null);
  const [currentCategory, setCurrentCategory] = useState<string>('');
  const [query, setQuery] = useState<string | undefined>(undefined);

  const toggleDropdown = (index: number) => {
    if (isDropdownOpen === index) {
      setIsDropdownOpen(null);
      setShowSubMenu(false);
    } else {
      setIsDropdownOpen(index);
      if (mockNavItems[index].subcategories) {
        setShowSubMenu(true);
        setCurrentSubMenu(mockNavItems[index].subcategories || null);
        setCurrentCategory(mockNavItems[index].label);
      } else {
        setShowSubMenu(false);
      }
    }
  };

  const openSubMenu = (index: number) => {
    setShowSubMenu(true);
    setCurrentSubMenu(mockNavItems[index].subcategories || null);
    setCurrentCategory(mockNavItems[index].label);
    setIsDropdownOpen(index);
  };

  const goBack = () => {
    setShowSubMenu(false);
    setCurrentSubMenu(null);
  };

  const closeMenu = () => {
    setIsDropdownOpen(null)
    setIsMobileMenuOpen(false)
  }

  useEffect(() => {
    if (isMobileMenuOpen || isDropdownOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isMobileMenuOpen, isDropdownOpen]);

  return (
    <nav className="bg-white text-black py-4 flex items-center justify-between z-50 border-b-2 relative fixed"  style={{ position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 100 }}>
      <div className="container flex items-center relative m-auto justify-between lg:py-0 px-4 lg:px-4 md:px-4 sm:px-2 xs:px-0 2xs:px-0 3xs:px-0">
        <div className="flex-shrink-0 ml-0 flex items-center lg:hidden">
          <div className="mr-2 flex lg:hidden">
            <button
              type="button"
              className="inline-flex items-center justify-center py-2 rounded-md text-gray-700 focus:outline-none"
              onClick={() => { setIsMobileMenuOpen(!isMobileMenuOpen); setIsDropdownOpen(null); setShowSubMenu(false); setCurrentSubMenu(null); }}
            >
              {isMobileMenuOpen ? (
                <svg
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  width="1em"
                  height="1em"
                  className="h-6 w-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  ></path>
                </svg>
              ) : (
                <svg
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="#ff9900"
                  width="1em"
                  height="1em"
                  className="h-6 w-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2.8"
                    d="M4 6h16M4 12h12M4 18h7"
                  ></path>
                </svg>
              )}
            </button>
          </div>
        </div>
        <Link role="link" aria-label="ZEUS" to="/" className='w-[calc(100%-64px)] lg:hidden flex justify-center'>
          <img className='cursor-pointer self-center' src={logo} alt='logo' style={{ width: '80px', height: '30px' }}/>
        </Link>
        <div className="w-full lg:flex hidden">
          <div className="flex items-center max-w-screen-2xl relative m-auto w-full items-center w-full gap-[50px]">
            <Link role="link" aria-label="ZEUS" to="/">
              <img className='cursor-pointer' src={logo} alt='logo' style={{ width: '90px', height: '35px' }}/>
            </Link>
            <div className="w-full flex items-center justify-start lg:space-x-3 pl-3 pr-2 xl:px-8 xl:space-x-8 xl:pl-12">
            {mockNavItems.map((item, index) =>
                item.subcategories ? (
                  <div
                    key={index}
                    className="relative"
                    onClick={() => toggleDropdown(index)}
                  >
                    <a href={item.href} className="hover:text-gray-300 flex items-center">
                      {item.label}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className={`w-4 h-4 ml-1 transition-transform duration-200 ${
                          isDropdownOpen === index ? 'transform rotate-180' : ''
                        }`}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                        />
                      </svg>
                    </a>
                    {isDropdownOpen === index && (
                      <div className="absolute left-1/2 -translate-x-1/2 mt-[30px] top-full mt-5 bg-white rounded-md shadow-lg p-4 z-50 max-h-[60vh] overflow-y-auto">
                        <div className="grid grid-cols-auto gap-8 max-w-[50vw]" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))' }}>
                          {item.subcategories.map((category, catIndex) => (
                            <div key={catIndex}>
                              <h3 className="font-semibold mb-2 text-sm">{category.title}</h3>
                              <ul>
                                {category.items.map((subItem, subIndex) => (
                                  <li key={subIndex}>
                                    <a
                                      href={subItem.href}
                                      className="block hover:text-gray-300 text-xs leading-5"
                                    >
                                      {subItem.label}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <a key={index} href={item.href} className="hover:text-gray-300">
                    {item.label}
                  </a>
                )
              )}
            </div>
          </div>
        </div>
        <div className="flex items-center space-x-4 bg-[#ff9900] p-1.5 rounded-md" onClick={() => setIsSearchOpen(!isSearchOpen)}>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 cursor-pointer">
            <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
          </svg>
        </div>
      </div>

      {isMobileMenuOpen && (
      <div className={`fixed top-[74px] text-black bg-white lg:bg-[#121212] left-0 w-full h-[calc(100vh-64px)] md:w-1/2 lg:w-1/3 2xl:w-1/4 z-50 ${showSubMenu ? 'flex flex-col' : 'overflow-y-auto '}`}>
        {showSubMenu ? (
          <>
            <div className="p-4 border-b-4 mb-4 flex flex-row items-center justify-between">
              <button onClick={goBack} className="flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-5 h-5 mr-2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15.75 19.5L8.25 12l7.5-7.5"
                  />
                </svg>
              </button>
              <div className="flex-grow flex justify-center">
                <span className="font-bold">{currentCategory}</span>
              </div>
          </div>
            <div className="flex-1 overflow-y-auto p-4 pt-0 pb-[100px]">
              <div className="flex flex-col space-y-4">
                {currentSubMenu?.map((category, catIndex) => (
                  <div key={catIndex}>
                    <h3 className="font-semibold mb-2 text-sm">{category.title}</h3>
                    <ul>
                      {category.items.map((subItem, subIndex) => (
                        <li key={subIndex}>
                          <a
                            href={subItem.href}
                            className="block hover:text-gray-300 text-xs leading-5"
                          >
                            {subItem.label}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          </>
        ) : (
          <div className="flex flex-col p-4 pt-0 pb-16">
            {mockNavItems.map((item, index) =>
              item.subcategories ? (
                <button
                  key={index}
                  onClick={() => openSubMenu(index)}
                  className="hover:text-gray-300 py-2 w-full text-left flex items-center justify-between"
                >
                  {item.label}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className='w-4 h-4 ml-1 transition-transform'
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                    />
                  </svg>
                </button>
              ) : (
                <a key={index} href={item.href} className="hover:text-gray-300 py-2">
                  {item.label}
                </a>
              )
            )}
          </div>
        )}
      </div>
    )}
    {(isMobileMenuOpen || isDropdownOpen) && ( <div onClick={closeMenu} className="fixed top-[76px] lg:absolute lg:top-full left-0 right-0 h-[calc(100vh-62px)] bg-[#8C8D8F] opacity-50 w-full z-20"></div> )}
    {isSearchOpen && ( 
      <div className="fixed top-[76px] lg:absolute lg:top-full left-0 right-0 h-[50px] bg-[#494851] opacity-90 w-full z-30">
        <div className='container mx-auto flex items-center text-white h-full p-5 md:p-3'>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 cursor-pointer mr-3">
            <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
          </svg>
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search"
            className="bg-transparent outline-none text-white placeholder-white w-full flex items-end"
          />
          <X
            className="size-5 cursor-pointer text-white hover:text-red"
            onClick={() => { setQuery(undefined); setIsSearchOpen(false); }}
          />
        </div>
      </div> 
    )}
    </nav>
  );
};

export default Navbar